(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/carousel-image-aspect.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/carousel-image-aspect.js');

'use strict';

const CarouselImageAspect = Object.freeze({
  SQUARE: 'SQUARE',
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
  WIDESCREEN: 'WIDESCREEN'
});
if (svs.isServer) {
  module.exports = {
    CarouselImageAspect
  };
} else {
  setGlobal('svs.components.tbUi.carousel.CarouselImageAspect', CarouselImageAspect);
}

 })(window);